import cancelIcon from '@SvgIcon/close.svg'
import checkIcon from '@SvgIcon/checkmark.svg'
import handleIcon from '@SvgIcon/grid.svg'
import trashIcon from '@SvgIcon/trash-b.svg'

import svgIconHtml from '../../svgIconHtml'

export default {
  name: 'UiFormRepeaterItem',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div class="form-repeater-item">
      <div class="form-repeater-item__sort-handle" v-if="sortable">
        ${svgIconHtml(handleIcon)}
      </div>
      <div class="form-repeater-item__fields" :class="{ 'inline-fields': inlineFields }">
        <div class="form-repeater-item__actions">
          <slot name="actions">
            <div class="remove-action">
              <template v-if="pendingRemoval">
                <button
                  type="button"
                  class="clear button alert"
                  @click="finishRemove"
                >
                  ${svgIconHtml(checkIcon)}
                </button>
                <button
                  type="button"
                  class="clear button"
                  @click="cancelRemove"
                >
                  ${svgIconHtml(cancelIcon)}
                </button>
              </template>
              <button
                v-else
                type="button"
                class="clear button alert"
                @click="startRemove"
              >
                ${svgIconHtml(trashIcon)}
              </button>
            </div>
          </slot>
        </div>
        <slot :item="modelValue"></slot>
      </div>
    </div>
  `,

  props: {
    modelValue: {
      type: Object,
      required: true,
      // FormRepeater expects all items to have an `id` property.
      default() {
        return {
          id: null,
        }
      },
    },
    confirmDelete: {
      type: Boolean,
      default: true,
    },
    inlineFields: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pendingRemoval: false,
    }
  },

  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.$emit('update:modelValue', this.modelValue)
      },
    },
  },

  methods: {
    startRemove() {
      if (this.confirmDelete) {
        this.pendingRemoval = true
      } else {
        this.finishRemove()
      }
    },
    cancelRemove() {
      this.pendingRemoval = false
    },
    finishRemove() {
      this.$emit('remove', this.modelValue)
    },
  },
}
